export const DESCRIPTION_MAX_LENGTH = 255;

export const ALLOWED_FILE_TYPES = [
  "image/png",
  "image/PNG",
  "image/jpg",
  "image/JPG",
  "image/jpeg",
  "image/JPEG",
  "image/gif",
  "image/GIF",
  "application/excel",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/x-excel",
  "application/x-msexcel",
  "application/pdf",
  "application/doc",
  "application/ms-doc",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export var MESSAGES = {
  name_too_long: "Document name is too long",
  filename_too_long: "Document filename is too long",
  doc_type_invalid: "Document type is invalid",
  expiration_date_invalid: "Document expiration date is invalid",
  description_too_long: "Document description is too long",
  document_not_found: "Document not found",
};
